import React from "react";
import { Switch, Redirect } from "react-router-dom";

import RouteWithLayout from "zq-ui-v3/layouts/RouteWithLayout";
// import MainLayout from "../layouts/BaseLayout";
import NotFound from "../pages/NotFound";
// import menus from "./menus";
import Loadable from "./Loadable";
import { reduceByTree } from "zq-ui-v3/utils/tree";

import Profile from "../pages/Profile";

import { useSelector } from "react-redux";
import Home from "@src/pages/Home";

export const setLastUrl = (location) => {
  if (location.pathname !== "/Login") {
    localStorage.setItem("_last_history_url", JSON.stringify(location));
  }
};

export const routes: Array<any> = [];

const Routes: React.FC = () => {
  const menus = useSelector((state: any) => state.profile?.menuTree);

  const routesMap = reduceByTree(
    { items: menus },
    (re, page) => {
      const path = page.path || page._id;
      if (!path) return re;
      re[path] = {
        path,
        layout: null,
        component: Loadable({
          path: path?.substring(0, path?.indexOf(":") === -1 ? undefined : path.indexOf(":") - 1),
          title: page.title,
          hasChild: page?.items?.length > 0,
          items: page?.items || [],
        }),
        isAuth: page.isAuth,
        exact: true,
      };
      return re;
    },
    {},
  );
  // .reduce((map, route) => {
  //   map[route.path] = route;
  //   return map;
  // }, {});
  const list = Object.values(routesMap);
  console.log(list);

  console.log(list);
  routes.push(...list);

  routes.push({ path: "/profile", component: Profile, layout: null });
  routes.push({ path: "/", component: Home, layout: null });

  routes.push({
    component: NotFound,
    layout: null,
    path: "/*",
  });

  return (
    <Switch>
      {routes.map((route) =>
        route.path ? (
          <RouteWithLayout key={String(route.path)} {...route} />
        ) : (
          <Redirect key={String(route.to)} {...route} />
        ),
      )}
    </Switch>
  );
};

export default Routes;
